/**
 * Contrato de colores para catalog.cards.* (Productos destacados + Catálogo).
 * Propietario del valor: catalog.cards; un campo vacío HEREDA estos defaults.
 * Mantener sincronizado con el módulo homónimo de WEB_GENERICA.
 * No tomar este estilo desde visualStyle.elementColors ni de la paleta del tema:
 * el preview y la web pública deben resolver exactamente la misma precedencia.
 */
export const CATALOG_CARD_COLOR_FALLBACKS = Object.freeze({
  surface: "#FFFFFF",
  type: "#F35A3A",
  title: "#1A1A2E",
  category: "#F35A3A",
  subcategory: "#5B5D73",
  description: "#5B5D73",
  price: "#19242F",
  buttonText: "#FFFFFF",
  buttonBackground: "#F35A3A",
});

function configuredColor(value, fallback) {
  return typeof value === "string" && value.trim() ? value.trim() : fallback;
}

export function resolveCatalogCardButtonColors(config = {}) {
  const normalBackground = configuredColor(config?.buttonBackgroundColor, CATALOG_CARD_COLOR_FALLBACKS.buttonBackground);
  const normalText = configuredColor(config?.buttonTextColor, CATALOG_CARD_COLOR_FALLBACKS.buttonText);
  return {
    background: normalBackground,
    text: normalText,
    hoverBackground: configuredColor(config?.buttonHoverBackgroundColor, normalBackground),
    hoverText: configuredColor(config?.buttonHoverTextColor, normalText),
  };
}

/** Replica la precedencia de catalogCardBoxShadow de la web pública. */
export function catalogCardPreviewShadow(config = {}, fallback) {
  const keys = ["shadowOpacity", "shadowX", "shadowY", "shadowBlur", "shadowSpread"];
  const hasGeometry = keys.some((key) => Object.prototype.hasOwnProperty.call(config, key) && config[key] !== "" && config[key] !== null && config[key] !== undefined);
  if (!hasGeometry) return config.shadowColor ? `0 8px 24px ${config.shadowColor}` : fallback;
  const bounded = (key, defaultValue, min, max) => {
    const raw = config[key];
    const number = raw === "" || raw === null || raw === undefined ? defaultValue : Number(raw);
    return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : defaultValue;
  };
  const opacity = bounded("shadowOpacity", 1, 0, 1);
  if (opacity <= 0) return "none";
  const x = bounded("shadowX", 0, -100, 100);
  const y = bounded("shadowY", 8, -100, 100);
  const blur = bounded("shadowBlur", 24, 0, 160);
  const spread = bounded("shadowSpread", 0, -80, 80);
  const color = config.shadowColor || "#000000";
  const renderedColor = opacity >= 0.999 ? color : `color-mix(in srgb, ${color} ${Math.round(opacity * 1000) / 10}%, transparent)`;
  return `${x}px ${y}px ${blur}px ${spread}px ${renderedColor}`;
}
